<template>
  <v-container class="alert-schedule-container">
    <v-time-picker v-model="selectedTime" landscape width="200"></v-time-picker>
  </v-container>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const EMITTED_ACTIONS = {
  INPUT: "input",
};

export default {
  name: "ScheduleEditor",
  props: {
    value: {
      type: String,
      required: true,
      default: "",
    },
  },
  data() {
    let selectedTime = dayjs().format("HH:mm");
    if (this.value) {
      selectedTime = this.getTime(this.value);
    }
    return {
      selectedTime,
    };
  },
  methods: {
    getTime(schedule) {
      const scheduleParts = schedule.split(" ");

      let timestamp = dayjs("1970-01-01", "YYYY-MM-DD");
      const offset = timestamp.utcOffset();
      timestamp = timestamp.utcOffset(0);
      timestamp = timestamp.hour(scheduleParts[1]);
      timestamp = timestamp.minute(scheduleParts[0]);
      timestamp = timestamp.utcOffset(offset);
      const results = timestamp.format("HH:mm");
      return results;
    },
    getSchedule(time) {
      let utcTime = dayjs("1970-01-01 " + time, "YYYY-MM-DD HH:mm");
      utcTime = utcTime.utcOffset(0);
      const min = utcTime.minute();
      const hour = utcTime.hour();
      return min + " " + hour + " * * *";
    },
  },
  watch: {
    selectedTime() {
      const schedule = this.getSchedule(this.selectedTime);
      this.$emit(EMITTED_ACTIONS.INPUT, schedule);
    },
  },
};
</script>

<style>
.alert-schedule-container {
}
</style>
